import * as React from 'react';
import { ActionAfterViewed } from '@cian/action-after-viewed-component';
import { useSelector } from 'react-redux';

import { Newbuildings } from '../../components/Newbuildings';
import { getDisplayName, getRegionId, getSimilarNewbuildings } from '../../selectors/newbuilding';
import { trackSimilarNewbuildingsBlockAppearance, trackTransferToSimilarNewbuilding } from './tracking';

export function SimilarNewbuildingsContainer() {
  const displayName = useSelector(getDisplayName);
  const regionId = useSelector(getRegionId);
  const newbuildings = useSelector(getSimilarNewbuildings);

  const onAppear = React.useCallback(() => {
    trackSimilarNewbuildingsBlockAppearance(newbuildings);
  }, [newbuildings]);

  const onNewbuildingClick = React.useCallback(
    (index: number) => {
      trackTransferToSimilarNewbuilding(newbuildings, index);
    },
    [newbuildings],
  );

  if (newbuildings.length === 0) {
    return null;
  }

  const title = `Жилые комплексы, похожие на ${displayName}`;

  return (
    <ActionAfterViewed callback={onAppear}>
      <Newbuildings
        title={title}
        regionId={regionId}
        newbuildings={newbuildings}
        onNewbuildingClick={onNewbuildingClick}
      />
    </ActionAfterViewed>
  );
}
